import { MRT_ColumnDef } from "material-react-table"
import { useMemo } from "react"
import { IAgendaCorporativo } from "../interfaces/erp/agenda_corporativo"
import { EstadosOrdenTrabajoEnumChoice } from "../constants";


export const useTableColumnsOrdenTrabajoCorporativo = (_estado: EstadosOrdenTrabajoEnumChoice) => {


  const columnsAgendaCoporativo = useMemo<MRT_ColumnDef<IAgendaCorporativo>[]>(() => [
    {
      accessorKey: 'razon_social',
      header: 'razon social',
      Cell: ({ row }) => `${row.original.prospecto_corporativo_data?.razon_social}`
    },
    {
      accessorKey: 'identificacion',
      header: 'identificacion',
      Cell: ({ row }) => `${row.original.prospecto_corporativo_data?.identificacion}`
    },
    {
      accessorKey: 'estado_agenda',
      header: 'Estado agenda'
    },
    {
      accessorKey: 'fecha_instalacion',
      header: 'Fecha instalacion'
    },
    {
      accessorKey: 'hora_instalacion',
      header: 'Hora instalacion'
    },
    {
      accessorKey: 'flota',
      header: 'Flota'
    },
    {
      accessorKey: 'preventa_corporativa',
      header: 'Preventa corporativa'
    },

    {
      accessorKey: 'prospecto_corporativo',
      header: 'Prospecto corporativo',
    },
    {
      accessorKey: 'user_create',
      header: 'user create',
    },
    {
      accessorKey: 'fecha_creacion',
      header: 'Fecha creacion',
    },
    {
      accessorKey: 'fecha_modificacion',
      header: 'Fecha modificacion',
    },
  ], []);

  return {

    columnsAgendaCoporativo
  }
}